import { ComponentProps } from "react";
import { ComputeFieldComponent } from "../computeFields";
import { MultipleprintInExhibition } from "../types";
import { SeparatedList } from "./shared/utils";
import { partitionAndRenderRelatedExhibitions } from "./itinerant-exhibition";

export const ExhibitionMultipleprintDescriptionCF: ComputeFieldComponent<
  Pick<
    MultipleprintInExhibition,
    | "exhibition"
    | "expositionsDansEstampesMultiplesDescriptionExemplaireExpose"
    | "expositionsDansEstampesMultiplesDescriptionNumero"
    | "itinerantGroupId"
    | "itinerantOrder"
    | "itinerantNote"
  > & { id?: string }
> = ({ input, language, translation, ...props }) => {
  const t = translation ?? (() => "");
  return (
    <SeparatedList
      {...props}
      lineBreak={false}
      language={language}
      commaSeparated
      input={[
        <span
          key={1}
          dangerouslySetInnerHTML={{
            __html: input.exhibition?.expositionsDescriptionResume ?? "",
          }}
        />,
        input.expositionsDansEstampesMultiplesDescriptionExemplaireExpose && (
          <>
            {t("computeField.numeroExemplaireExpose")}{" "}
            {input.expositionsDansEstampesMultiplesDescriptionExemplaireExpose}
          </>
        ),
        input.expositionsDansEstampesMultiplesDescriptionNumero && (
          <>
            {t("computeField.numeroCatalogueAbbrege")}{" "}
            {input.expositionsDansEstampesMultiplesDescriptionNumero}
          </>
        ),
      ]}
    />
  );
};

export const RelatedExhibitionsMultipleprintCF: ComputeFieldComponent<{
  relatedExhibitions?: ComponentProps<
    typeof ExhibitionMultipleprintDescriptionCF
  >["input"][];
  groupItinerantExhibitions?: boolean;
}> = ({ input, lineBreak = true, language, ...props }) => {
  if (!input.relatedExhibitions || input.relatedExhibitions.length === 0) {
    return <></>;
  }
  if (!input.groupItinerantExhibitions) {
    return (
      <SeparatedList
        {...props}
        language={language}
        lineBreak={lineBreak}
        input={input.relatedExhibitions.map((ex, index) => (
          <ExhibitionMultipleprintDescriptionCF
            key={ex.id ?? ex.exhibition?.id ?? index}
            input={ex}
            language={language}
            {...props}
          />
        ))}
      />
    );
  }
  return (
    <>
      {partitionAndRenderRelatedExhibitions({
        links: input.relatedExhibitions,
        ClassicLine: ExhibitionMultipleprintDescriptionCF,
        language,
        lineBreak,
        getCatalogNumber: (link) =>
          link.expositionsDansEstampesMultiplesDescriptionNumero,
        ...props,
      })}
    </>
  );
};
